<template>
    <div>
        <!-- REQUEST TRANSCRIPT -->
        <div class="container-fluid"
             v-show="activeScreen === ScreensEnum.transcript">
            <div class="row">
                <div>
                    <div class="panel">
                        <div class="clearfix panel-heading branding-background branding-text chat-heading">
                            <h3 class="panel-title pull-left">Chat Ended</h3>
                            <div class="pull-right">
                                <a @click.prevent="nextScreen(ScreensEnum.chatButton)" href="" class="branding-text close-chat" title="Close Chat"><i class="glyphicon glyphicon-remove"></i></a>
                            </div>
                        </div><!--chat-heading-->
                        <div class="panel-body">
                            <p>If you would like a transcript of this chat, please enter your email address below.</p>
                            <div class="form-group" :class="{'has-error' : isUserEmailChangedAndInvalid}">
                                <label for="userEmail">Email <span class="text-danger">*</span></label>
                                <input @keyup.enter="emailTranscript" v-model="userEmail" v-validate="'required|email'" name="email" type="text" class="form-control" id="userEmail" maxlength="@VT.DataStore.Models.VisualTour.ChatSession.InitiateEmailAddressMaxLength">
                                <span class="text-danger">{{errors.first('email')}}</span>
                            </div>
                            <button @click="emailTranscript" class="btn btn-lg branding-background branding-text" id="">Send Transcript</button>
                        </div><!--chat-window-->
                    </div><!--panel-->
                </div><!--col-->
            </div><!--row-->
        </div><!--container-->
        <!-- REQUEST TRANSCRIPT SUCCESS -->
        <div class="container-fluid"
             v-show="activeScreen === ScreensEnum.transcriptSuccess">
            <div class="row">
                <div>
                    <div class="panel">
                        <div class="clearfix panel-heading branding-background branding-text chat-heading">
                            <h3 class="panel-title pull-left">Chat Ended</h3>
                            <div class="pull-right">
                                <a @click.prevent="nextScreen(ScreensEnum.chatButton)" href="" class="branding-text close-chat" title="Close Chat"><i class="glyphicon glyphicon-remove"></i></a>
                            </div>
                        </div><!--chat-heading-->
                        <div class="panel-body">
                            <p><strong>Transcript Sent</strong></p>
                            <p>A transcript of this chat has been sent successfully.</p>
                        </div><!--chat-window-->
                    </div><!--panel-->
                </div><!--col-->
            </div><!--row-->
        </div><!--container-->
    </div>
</template>

<script>
import screenNavMixin from '../mixins/screen-nav';

export default {
        mixins: [screenNavMixin],
        computed: {
            userEmail: {
                get: function () {
                    return this.sharedStore.state.user.email;
                },
                set: function (val) {
                    this.sharedStore.mutations.setUser({ email: val });
                }
            },
            isUserEmailChangedAndInvalid: function () {

                if (_.isEmpty(this.fields)) {
                    return true;
                }
                return this.fields.email.changed && this.fields.email.invalid;

            },
            isFormValid: function () {

                // On component init, this is empty
                // so just return false
                if (_.isEmpty(this.fields)) {
                    return false;
                }

                return this.fields.email.valid;
            }
        },
        methods: {
            emailTranscript: function () {
                const vm = this;
                vm.$validator.validate()
                    .then(function (isValid) {

                        // If not valid then return
                        if (!isValid) {
                            return;
                        }

                        // Note: At this point in the workflow,
                        // we need to update the chat session record
                        // with users email before sending the transcript.
                        vm.$chatService.updateConversation({ InitiateEmail: vm.userEmail })
                            .then(function () {
                                // Fire and forget
                                vm.$chatService.emailTranscript(vm.userEmail);
                            });

                        // Move to success screen
                        vm.nextScreen(vm.ScreensEnum.transcriptSuccess);

                    });
            }
        }    
};
</script>

<style>
</style>